import { useState } from "react";

/**
 * CopyBlock — a small reusable container used across the Media Kit
 * page. Renders a labelled block of text with a one-click "Copy"
 * button (clipboard) so journalists can lift bios + quotes cleanly.
 */
export default function CopyBlock({
  eyebrow,
  body,
  meta,
  testid,
  textForClipboard,
  dark = false,
}) {
  const [copied, setCopied] = useState(false);

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(textForClipboard || body);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch {
      /* no-op */
    }
  };

  return (
    <div
      data-testid={testid}
      className={`relative group border-t ${
        dark ? "border-white/15" : "border-[color:var(--rule)]"
      } pt-8 md:pt-10`}
    >
      <div className="flex items-baseline justify-between gap-6 mb-4">
        {eyebrow && (
          <p className="hairline opacity-60">{eyebrow}</p>
        )}
        <button
          type="button"
          onClick={onCopy}
          data-testid={`${testid}-copy`}
          className="hairline opacity-70 hover:opacity-100 transition-opacity shrink-0"
        >
          {copied ? "Copied ✓" : "Copy"}
        </button>
      </div>
      <p
        className={`font-serif italic text-lg md:text-xl leading-[1.55] ${
          dark ? "opacity-90" : "opacity-90"
        }`}
      >
        {body}
      </p>
      {meta && (
        <p className="hairline opacity-55 mt-5">{meta}</p>
      )}
    </div>
  );
}
